<!--TODO da sistemare-->
<div class="avatar-space pt-5" *ngIf="user">
  <div class="d-flex align-items-center justify-content-around flex-wrap flex-sm-nowrap">
    <div class="avatar-wrapper">
      <div class="avatar avatar-secondary"
           [ngClass]="{'size-xl': !sidebarService.isSidebarActive(), 'size-md': sidebarService.isSidebarActive()}">
        <img src="./assets/icons/social.svg" alt="{{user?.uida}}"
             *ngIf="usersService.activeRole !== UserPrimaryRoleConstants.OCC">
        <svg class="icon icon-white" *ngIf="usersService.activeRole === UserPrimaryRoleConstants.OCC">
          <use xlink:href="assets/svg/sprite.svg#it-telephone"></use>
        </svg>
        <span class="sr-only">{{'HEADER.USER' | translate}}</span>
        <div class="avatar-presence active">
          <span class="sr-only">Presenza: attivo</span>
          <div class="nav-item dropdown" *ngIf="!sidebarService.isSidebarActive()">
            <a
              class="nav-link dropdown-toggle"
              href="#"
              data-toggle="dropdown"
              aria-expanded="true"
            >
              <i class="fas fa-angle-down fa-lg"></i>
            </a>
            <div class="dropdown-menu">
              <div class="link-list-wrapper">
                <ul class="link-list">
                  <li>
                    <a class="list-item cursor-pointer" (click)="managePassword()">
                      <span>{{'SIDEBAR.PASSWORD' | translate}}</span>
                    </a>
                  </li>
                  <li><span class="divider"></span></li>
                  <li>
                    <a class="list-item cursor-pointer" (click)="logout()">
                      <span>{{'SIDEBAR.USER.LOGOUT' | translate}}</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--  sezione sotto avatar-->
  <!--se sidebar chiusa-->
  <div class="row justify-content-center m-0 p-0" *ngIf="sidebarService.isSidebarActive()">
    <a
      class="nav-link dropdown-toggle p-0"
      href="#"
      data-toggle="dropdown"
      aria-expanded="true"
    >
      <i class="fas fa-angle-down fa-lg"></i>
    </a>
    <div class="dropdown-menu">
      <div class="link-list-wrapper">
        <ul class="link-list">
          <li>
            <a class="list-item cursor-pointer">
              <span>{{'SIDEBAR.PASSWORD' | translate}}</span>
            </a>
          </li>
          <li><span class="divider"></span></li>
          <li>
            <a class="list-item cursor-pointer" (click)="logout()">
              <span>{{'SIDEBAR.USER.LOGOUT' | translate}}</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <!------------------------------------------------------------------------->
  <!--se sidebar aperta-->
  <div class="row m-0">
    <div class="row justify-content-center primary-color m-0 p-3 w-100">
      <h6 class="m-0 p-0" *ngIf="!sidebarService.isSidebarActive()">{{user?.name || user?.uida}}</h6>
      <div class="m-0 p-0" *ngIf="sidebarService.isSidebarActive()">{{user?.name || user?.uida}}</div>
    </div>
    <div class="row justify-content-center secondary m-0 p-0 w-100" style="font-size: smaller">
      <!--      ruoli-->
      <div id="user-roles" class="text-sm-center text-truncate d-block row m-0 p-1"
           title="{{'ROLE.' + usersService.activeRole | translate}}">{{('ROLE.' + usersService.activeRole | translate)}}
        <!--            popover circle-->
        <button *ngIf="secondaryRoles?.length>0" id="rolesInfo" type="button" class="badge badge-outline-tertiary mr-1"
                data-toggle="popover"
                data-trigger="hover">
          {{secondaryRoles?.length}}
        </button>
        <button *ngIf="activeExternalBadge" id="externalInfo" type="button" class="badge badge-outline-warning mr-1"
                data-toggle="popover"
                data-trigger="hover">
          {{countExternal}}
        </button>
        <!--        <i class="fas fa-exchange-alt ml-1 cursor-pointer primary-color"-->
        <!--           title="Cambia profilo" (click)="changeUser()"></i>-->
        <span class="ml-1 p-0" *ngIf="users?.length > 1">(
          <button class="btn btn-link primary-color p-0 m-0" style="font-size: x-small"
                  (click)="changeUser()">
            {{'SIDEBAR.USER.PROFILE_CHANGE' | translate}}
          </button>
          )
        </span>
      </div>
      <!--              roles popover content-->
      <div class="d-none">
        <div class="popover-body-roles">
          <div *ngFor="let r of secondaryRoles" class="row pl-1">
            <div
              *ngIf="r !== UserPrimaryRoleConstants.ORS && r!== UserPrimaryRoleConstants.OPV && r!== UserPrimaryRoleConstants.OCC">
              <li>{{'ROLE.' + r | translate}}</li>
            </div>
          </div>
        </div>
      </div>
      <!--              end content-->

      <!--              external roles popover content-->
      <div class="d-none">
        <div class="popover-body-external-roles">
          <div *ngFor="let u of users" class="row pl-1">
            <div *ngIf="u.external">
              <div class="row m-0 font-weight-bolder">{{'APP_ID.' + u.appId | translate}}</div>
              <ng-container *ngFor="let r of u.roles" class="row pl-1">
                <li>{{'ROLE.' + r | translate}}</li>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
      <!--              end content-->

      <div class="row w-100 m-1"></div>  

      <div class="row secondary m-0 p-0 justify-content-center" *ngIf="clientAccountService.getClient()">
        <div class="row align-items-center justify-content-center" *ngIf="!sidebarService.isSidebarActive()">
          <div style="font-size: small"
               class="text-truncate d-block p-0">{{clientAccountService.getClient().customerCode}}</div>
          <div style="font-size: small" class="text-truncate d-block p-0" *ngIf="clientAccountService.getAccount()">
            &nbsp;
            / {{clientAccountService.getAccount().accountCode}}</div>
          <div class="ml-1 p-0" *ngIf="!clientAccountService.isUserOnlyUnit()">(
            <button class="btn btn-link primary-color p-0 m-0" style="font-size: small"
                    (click)="changeClienteAccount()">
              {{'SIDEBAR.USER.UNIT_CHANGE' | translate}}
            </button>
            )
          </div>
        </div>
        <div *ngIf="sidebarService.isSidebarActive()" class="ml-1 p-0">
          <i class="fas fa-network-wired primary-color cursor-pointer"
             [attr.title]="'SIDEBAR.USER.UNIT_CHANGE' | translate"
             (click)="changeClienteAccount()"></i>
        </div>
      </div>
    </div>
  </div>
</div>
 <app-separator></app-separator>

